import { render } from "./CadastroSinistrosView.vue?vue&type=template&id=5587265d&scoped=true"
import script from "./CadastroSinistrosView.vue?vue&type=script&lang=js"
export * from "./CadastroSinistrosView.vue?vue&type=script&lang=js"

import "./CadastroSinistrosView.vue?vue&type=style&index=0&id=5587265d&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5587265d"]])

export default __exports__